import { render, staticRenderFns } from "./LectureCourseSelect.vue?vue&type=template&id=7f7f9be8&scoped=true&"
import script from "./LectureCourseSelect.vue?vue&type=script&lang=ts&"
export * from "./LectureCourseSelect.vue?vue&type=script&lang=ts&"
import style0 from "./LectureCourseSelect.vue?vue&type=style&index=0&id=7f7f9be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7f9be8",
  null
  
)

export default component.exports